import React from 'react';

const LoadingSpinner = () => {
  return (
    <div style={{ display: 'inline-block', border: '2px solid #8267DB', borderTop: '2px solid #ffffff', borderRadius: '50%', width: '16px', height: '16px', animation: 'spin 1s linear infinite' }}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingSpinner;